import { mockCmsArea, mockCmsPage } from '@domgen/dgx-fe-cms';
import { CmsArticleSearchPage } from '../../models/article-search/cms/cms-article-search-page.interface';

export const mockCmsArticleSearchPage: CmsArticleSearchPage = {
  ...mockCmsPage,
  brand: {
    brandName: 'Beko',
    brandTermsAndConditionsSmallDomesticApplianceCare: '',
    brandTermsAndConditionsApplianceCare: '',
    brandAverageCallOut: '',
    name: 'beko',
    brandPrivacyPolicy: '',
    brandIpidSmallDomesticApplianceCare: '',
  },
  category: {
    name: 'articles',
    title: 'articles',
  },
  subcategory: {
    name: 'articles',
    title: 'articles',
  },
  articleTitle: 'Article Title',
  main: mockCmsArea,
  name: 'article',
};
